import { DateColumn } from './date-column';
import { DateColumnComponent } from './date-column.component';
import { DateHeader } from './date-header';
import { DateHeaderColumn } from './date-header-column';
import { FormField } from '../../common/register/form-field';

export class DateField extends FormField {
  constructor(item, header: DateHeader) {
    super(item, header);

    this.grid = [
      this.header.columns.map(
        (headerColumn) => new DateColumn(item, headerColumn as DateHeaderColumn, DateColumnComponent),
      ),
    ];
  }
}
